import React from 'react';

const DealersConditions = () => {
    return (
        <>
            <h2 style={{textAlign: 'center'}} className="blacktitle titlecentered">Dealers Terms and Conditions
                Dealers/Group Leaders/Charterers</h2>
            <div
                className="wp-block-ugb-button ugb-button-wrapper smallcontainer ugb-d238e2f ugb-button--design-plain ugb-main-block"
                id="">
                <div className="ugb-inner-block">
                    <div className="ugb-block-content">
                        <div className="ugb-button-container"><a
                            className="ugb-button1 ugb-button ugb-button--size-normal"
                            href="https://nautilusliveaboards.com/wp-content/uploads/2022/09/2021-12-Dealer-TC1.pdf"
                            target="_blank" rel="noopener noreferrer"><span
                            className="ugb-button--inner">Download Terms &amp; Conditions</span></a></div>
                    </div>
                </div>
            </div>
            <br/>
            <p className="has-medium-font-size smallcontainer"><strong>The following are the terms and conditions that
                are binding on you (our independent dealers,
                group leaders and charterers) and these terms are not negotiable.</strong></p>

            <h5 className="smallcontainer">Commissions and Representative Obligations</h5>
            <p className="smallcontainer">
                Commissions payable for each trip shall be determined by the parties at the time of booking and, unless
                otherwise agreed, shall be such rates of commission as are advised by Nautilus from time to time.
                Commissions are payable on the basis that the Representative assumes responsibility for the guests
                booked including providing the guests with Nautilus pre-trip information; obtaining and submitting all
                required documentation; collecting all amounts charged and submitting payments on or before the
                scheduled time for payment; and communicating information to the guests after confirmation of the trip
                has been given by Nautilus.
            </p>

            <h5 className="smallcontainer">Payment Schedule and Method</h5>
            <p className="smallcontainer"><strong>1 – 4 Divers:</strong></p>
            <ul className="smallcontainer">
                <li>25% advance payment within 7 days of booking to confirm your reservation;</li>
                <li>additional 25% due 4 months prior to departure date; and</li>
                <li>balance due 60 days prior to departure.</li>
            </ul>
            <p className="smallcontainer"><strong>5 or more Divers:</strong></p>
            <ul className="smallcontainer">
                <li>bookings made more than 18 months prior to departure require a USD $1500 payment
                    with balance of 10% of the trip fees due at 18 months, or 10% of trip fees if less than
                    USD $1500;
                </li>
                <li>bookings made within 18 months of departure date require a 10% payment within 10
                    days of booking to confirm your reservation;
                </li>
                <li>additional payment of 10% due 9 months before the departure date;</li>
                <li>additional payment of 20% due 6 months before the departure date; and</li>
                <li>remaining payment of 60% due 60 days before the departure date.</li>
            </ul>
            <p className="smallcontainer">Initial non-refundable payments can be paid by Visa, Mastercard, or American Express. Subsequent
                interim payments and final payments must be made by certified company cheque, bank draft, or bank
                wire. Your Confirmation Number & Departure Date must be included with every payment or followed by an
                email with this information.</p>

            <h5 className="smallcontainer">Final Payment</h5>
            <p className="smallcontainer">
                Final payment of the net due (i.e. gross guest charges less commission owed by your guests to you) must
                be remitted by bank wire transfer or bank draft 60 days before the departure date. We reserve the right to
                sell reserved berths if payment is not made on time and the initial payment may be forfeited.
            </p>

            <h5 className="smallcontainer">Insurance – PLEASE BE SURE TO REVIEW THIS SECTION AND INFORM YOUR GUESTS</h5>
            <p className="smallcontainer">
                Medical evacuation from remote locations such as Socorro and treatment can be
                very expensive. We require all guests to either purchase medical diving insurance from us or to have
                proof of valid insurance from a recognized and reputable insurance carrier such as DAN or DiveAssure.
            </p>
            <p className="smallcontainer">
                Please Note: Travel insurance is different than medical dive insurance and provides peace of mind and
                financial security as it provides coverage for delay, missed departures due to weather, canceled flights,
                lost bags etc. We highly recommend DiveAssure travel insurance which the guests can purchase from us.
            </p>

            <h5 className="smallcontainer">Releasing Berths</h5>
            <p className="smallcontainer">
                Whole boat bookings - You may release 4 berths without penalty up to 6 months prior to the departure
                date. Please note that by reducing your reservation you may lose your FOC space.
            </p>
            <p className="smallcontainer">
                Half boat bookings - You may release 2 berths without penalty up to 6 months prior to the departure date.
                Please note that by reducing your reservation you may lose your FOC space.
            </p>

            <h5 className="smallcontainer">Cancellation</h5>
            <p className="smallcontainer">If a berth is canceled by you or your guest, a percentage of the trip price will be forfeited:</p>
            <p className="smallcontainer"><strong>Reservation of 1 – 4 Divers: </strong></p>
            <ul className="smallcontainer">
                <li>15% if 12 - 9 months prior to departure;</li>
                <li>25% if 9 - 4 months prior to departure;</li>
                <li>50% if 4 - 2 months prior to departure; and</li>
                <li>100% if 60 days or less prior to departure.</li>
            </ul>
            <p className="smallcontainer"><strong>Reservation of 5 or more divers: </strong></p>
            <ul className="smallcontainer">
                <li>10% if 18 - 9 months prior to departure;</li>
                <li>20% if 9 - 6 months prior to departure;</li>
                <li>40% if 6 - 2 months prior to departure; and</li>
                <li>100% if 60 days or less prior to departure.</li>
            </ul>
            <p className="smallcontainer">
                We reserve the right to cancel your reservation in the event that any due payment is not made when
                required and to retain any and all forfeited payments received in advance in the event that we are not able
                to find an alternate person(s) to occupy the previously reserved berth(s).
            </p>
            <h5 className="smallcontainer">Refunds</h5>
            <p className="smallcontainer">
                A cancellation of an original booking (a booking that has not been previously transferred to a later date
                than when first booked) that is received more than a year before departure is fully refundable less an
                administrative fee of USD $175 per berth or the booking may be transferred to a new booking without any
                administrative fee. This option is only available once for each booking and transferred payments may only
                be applied as a credit to final payments. There are no refunds for any transferred bookings.
            </p>
            <ul className="smallcontainer">
                <li>1 - 4 Divers: Cancellations received more than 12 months prior to departure; and</li>
                <li>5 or more Divers: Cancellations received more than 18 months prior to departure.</li>
            </ul>

            <h5 className="smallcontainer">Paper Work</h5>
            <p className="smallcontainer">
                Each and every guest is required to provide a Waiver, Release and Indemnity (the “Release”) on or before
                arrival at the ship and their personal and travel information. You can provide a copy of these documents
                (found on the Nautilus web site or on request) to your guests electronically as soon as confirmation of the
                reservation has been given but, in any event, no later than 60 days prior to departure. The government of
                Mexico requires that we submit this information before the boarding day. If this is not done, guests may be
                refused boarding permission and you may be responsible for any and all loss, damage or expense
                Nautilus may suffer or incur as a result.
            </p>
            <p className="smallcontainer">
                You will also make sure that each guest provides all information Nautilus may require in respect of travel
                documentation and will ensure that each has the requisite documentation when traveling to the ship. The
                guests need to double check their travel documents (expiry etc.) and ensure they obtain any required
                visas to travel to or through the United States and Mexico if required.
            </p>
            <p className="smallcontainer">
                Guests who are unable to board the ship because they have been denied entry into the country or lack
                the proper documentation will not be issued a refund or credit.
            </p>

            <h5 className="smallcontainer">Special Requests</h5>
            <p className="smallcontainer">
                We want to serve your guests as best as we can by accommodating all reasonable special requests.
                Please let us know if we can help with any specific dietary requests or other accommodations at least 30
                days prior to boarding. The more notice the better we can serve everyone. It is unlikely that we will be
                able to respond to last minute or “day of” requests.
            </p>

            <h5 className="smallcontainer">Marketing Material and Policy</h5>
            <p className="smallcontainer">
                Nautilus will provide marketing material upon request. You may not alter trip descriptions, itineraries or
                images provided by Nautilus unless you have our express written permission. The booking commission
                rate is based on marketing and selling trips at our suggested pricing. We reserve the right to unilaterally
                alter your commission – possibly to 0% - should any trip be marketed at any other price without written
                agreement from us. You will not offer nor arrange any discount from the prices for trips advertised by
                Nautilus on its website.
            </p>

            <h5 className="smallcontainer">Surcharges</h5>
            <p className="smallcontainer">
                While Nautilus understands/appreciates guest reaction to post booking charges after a trip has been
                booked and shall avoid such whenever possible, we have to reserve the right to add a surcharge in
                respect of volatile fuel price increases and other unforeseen charges over which Nautilus has no control
                such as the cost of any imposition of any taxes, levies, fees or other unforeseen charges legislated by the
                Governments of Canada, USA or Mexico.
            </p>

            <h5 className="smallcontainer">Force Majeure</h5>
            <p className="smallcontainer">
                While we will always do whatever we can to ensure the absolute best possible experience for the guests,
                trip itineraries are subject to change or cancellation without notice at the discretion of the Captain taking
                into consideration the safety of guests, crew and the vessel for reasons such as inclement weather or
                seas, mechanical breakdown, governmental orders, port authority directions and other factors beyond our
                reasonable control. No refund or credit will be issued in such instance.
            </p>

            <h5 className="smallcontainer">Contract Changes</h5>
            <p className="smallcontainer">
                Prior to any accepted reservation, Nautilus reserves the right to make changes to the above noted terms
                and conditions without notice.
            </p>

            <h5 className="smallcontainer">Dealer Responsibilities</h5>
            <p className="smallcontainer">
                In engaging in business with Nautilus, you understand that: (a) you will ensure that all of your guests
                have agreed to the retail terms and conditions found on our website; (b) you are acting on their behalf in
                making the bookings for them; (c) you will be responsible for informing them of all information and
                documentation required by government authorities and ourselves; and (d) you will obtain this information
                and documentation and provide it to us within the established time lines. You agree to the above in
                consideration for the commission you will earn.
            </p>

            <h5 className="smallcontainer">Use of Credits</h5>
            <p className="smallcontainer">
                Credits are non-transferable. If you would like to use the credit for future trip, please talk to us. The trip
                must be taken within one year of the original trip and if the booking gets moved or cancelled the credit
                is void.
            </p>
        </>
    );
};

export default DealersConditions;